import React, { useEffect, useRef, useState } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import axios from 'axios';
import { Checkbox } from 'primereact/checkbox';
import { Editor } from 'primereact/editor';
import { IoArrowBackSharp } from 'react-icons/io5';
import { Api } from '../../../services/api';
import { Form555 } from '../../../services/Form/555-form';
import { MultiSelect } from 'primereact/multiselect';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Slider } from "primereact/slider";
import "./perforamce-review.css"
import SignatureModal from './SignatureModal ';
import { OrderList } from 'primereact/orderlist';
import DragMotivatorsTable from './DragMotivatorsTable';
import { BsFillInfoCircleFill } from 'react-icons/bs';

function PerformanceReviewForm() {
  const navigate = useNavigate();

  const [isSavePopupOpen, setIsSavePopupOpen] = useState(false);
  const [isSupervisor, setIsSupervisor] = useState(false);
  const [customMessage, setCustomMessage] = useState('');
  const [customSubject, setCustomSubject] = useState('Performance Review');

  const [to, setTo] = useState('Y');
  const [customCC, setCustomCC] = useState('Y');
  const [humanResourcesCC, setHumanResourcesCC] = useState('Y');
  const [vpConstructionCC, setVpConstructionCC] = useState('Y');
  const [presidentCC, setPresidentCC] = useState('Y');

  const [allSupervisors, setAllSupervisors] = useState([]);
  const [selectedCCList, setSelectedCCList] = useState([]);
  const { editId } = useParams();
  // console.log("editId, ", editId);

  const [showName, setShowName] = useState('');

  const [saveLoading, setSaveLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [toastMessage, setToastMessage] = useState('');

  const [Section1Array, setSection1Array] = useState(Form555.getPerformanceForm().section_2);
  const [Section2Array, setSection2Array] = useState(Form555.getPerformanceForm().section_3);
  const [Section3Array, setSection3Array] = useState(Form555.getPerformanceForm().section_4);
  const [Section4Array, setSection4Array] = useState(Form555.getPerformanceForm().section_5);


  const [signingUrl, setSigningUrl] = useState(null);

  // 08-11-2024 
  const [goals, setGoals] = useState([
    {
      id: 1,
      text: "Q3 Sales are $6.2m, FSAs are $3.2m, and building contracts are $4.1m - off-Track",
    },
    { id: 2, text: "Hire on estimator - Complete" },
    { id: 3, text: "Hire a PM - Complete" },
    { id: 4, text: "Read many books - On-track with one left to finish" },
    { id: 5, text: "Lose 5lbs - On-track with one pound left" },
  ]);



  const formik = useFormik({
    initialValues: {
      ...Form555.getPerformanceForm(),
      customMessage: '',
      customSubject: '',
      customCC: '',
      humanResourcesCC: '',
      vpConstructionCC: '',
      presidentCC: '',
      is_supervisor: false,
      to: '',
      cc_users: [],
    },
    validate: (data) => {
    },

    onSubmit: (data) => {
      setSaveLoading(true)
      console.log(JSON.stringify(data));
      data.user_id = localStorage.getItem('user_id');
      console.log(data.user_id)
      data.role_id = localStorage.getItem('role_id');

      const token = localStorage.getItem('authToken');
      const headers = {
        'Authorization': token ? `Bearer ${token}` : '',
        "Content-Type": "application/json",
      };

      data.workMotivators = workMotivators.map(motivator => motivator.name);

      fetch(Api.API_BASE_URL + 'performance-review/save', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          setSaveLoading(false);
          console.log(response)
          if (response.error != '') {
            setToastMessage(response.error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: response.error, life: 3000 });
          } else {
            setToastMessage(response.result);
            if (formik.values.employee_sign == 'Y' && formik.values.evaluated_by_sign == 'Y') {
              setIsSaveDisabled(true)
            }

            if (formik.values.employee_sign == 'Y') {
              setEmployeeSign(true)
            }
            if (formik.values.evaluated_by_sign == 'Y') {
              setEvaluatedBySign(true)
            }

            toast.current.show({ severity: 'success', summary: 'Success', detail: response.result, life: 3000 });
          }
          setTimeout(() => {
            setToastMessage('');
            setIsLoading(false);
          }, 5000);

        })
    },


  });

  const openSavePopup = (e) => {
    e.preventDefault();
    setIsSavePopupOpen(true);
  };

  const directSave = (e) => {
    e.preventDefault();
    formik.setFieldValue('customMessage', customMessage, true);
    formik.setFieldValue('customSubject', customSubject, true);
    formik.setFieldValue('customCC', customCC, true);
    formik.setFieldValue('humanResourcesCC', humanResourcesCC, true);
    formik.setFieldValue('vpConstructionCC', vpConstructionCC, true);
    formik.setFieldValue('presidentCC', presidentCC, true);
    formik.setFieldValue('notification_send', 'N');
    formik.handleSubmit();
  };

  const handleSaveSubmit = (e) => {
    e.preventDefault();
    var isNotificationAdmin = false;
    var user_id = localStorage.getItem('user_id');
    if (user_id == formik.values.supervisor_id) {

    } else if (user_id == formik.values.team_member_id) {

    } else { isNotificationAdmin = true; }

    formik.setFieldValue('isNotificationAdmin', isNotificationAdmin);
    formik.setFieldValue('notification_send', 'Y');
    formik.setFieldValue('customCc', customCC,);
    formik.setFieldValue('humanResourcesCC', humanResourcesCC,);
    formik.setFieldValue('vpConstructionCC', vpConstructionCC,);
    formik.setFieldValue('presidentCC', presidentCC,);
    formik.setFieldValue('customSubject', customSubject,);
    formik.setFieldValue('customMessage', customMessage,);
    formik.setFieldValue('to', to,);
    formik.setFieldValue('cc_users', selectedCCList.map(user => user.email));
    setIsSavePopupOpen(false);
    formik.handleSubmit();
  };

  //* --------------------------------------------------
  useEffect(() => {
    console.log('working')

    getProjectDetails();
    getUser();

    // getSignature()
    return () => {
      // Cleanup tasks before the component is unmounted
    };

  }, []);

  const getUser = async () => {
    try {
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      const response = await axios.get(Api.API_BASE_URL + 'get-all-users', { headers: headers });

      setAllSupervisors(response.data.result);

      // setSupervisor_id([...response.data.supervisor_id]);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching users:', error);
      setIsLoading(false);
    }
  };

  const getSignature = async () => {
    try {
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      const response = await fetch(Api.API_BASE_URL + 'send-envelop', { method: 'POST', headers: headers })
        .then(res => res.json())
        .then(data => setSigningUrl(data.url))
        .catch(error => console.error('Error creating signing session:', error));

      // setSupervisor_id([...response.data.supervisor_id]);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching users:', error);
      setIsLoading(false);
    }
  };


  const getProjectDetails = () => {

    var user_id = localStorage.getItem('user_id');
    var role_id = localStorage.getItem('role_id');
    var conversationId = 0;
    if (editId != undefined) {
      conversationId = editId;
    }

    // console.log('llllllllllllllllllllllll', conversationId)

    var _body = {
      user_id: user_id,
      role_id: role_id,
      conversationId: conversationId,

    };

    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    fetch(Api.API_BASE_URL + 'performance-review/get', {
      method: 'POST',
      body: JSON.stringify(_body),
      headers: headers
    })
      .then((response) => response.json())
      .then((response) => {
        setIsLoading(false);
        setIsSupervisor(response.isSuperVisor);

        formik.setFieldValue(`is_supervisor`, response.isSuperVisor);
        if (response.error != '') {

          //*----------- Set work motivators from section_12 ----------- 
          const motivators = response.section_12.title || [];
          const motivatorsArray = motivators.map((motivator, index) => ({
            id: index + 1, // Assign a unique id
            name: motivator,
          }));
          setWorkMotivators(motivatorsArray);

          // Set work motivators comment
          const comment = response.section_12.comments || '';
          setWorkMotivatorsComment(comment); // Update the state variable
          formik.setFieldValue('workMotivatorsComment', comment); // Set formik value
          //!----------- Set work motivators from section_12 ----------- 


          formik.setFieldValue(`team_member_name`, response.team_member_name);
          formik.setFieldValue(`supervisor_name`, response.supervisor_name);
          formik.setFieldValue(`supervisor_id`, response.supervisor_id);
          formik.setFieldValue(`team_member_id`, response.team_member_id);

          formik.setFieldValue(`conversationId`, 0);
          if (user_id == response.supervisor_id) {
            // setIsSupervisor(true);
          }
        } else {

          //*---------------------- 
          if (response.section_1.employee_sign == 'Y' && response.section_1.evaluated_by_sign == 'Y') {
            setIsSaveDisabled(true)
          }
          //!---------------------- 

          //*----------- Set work motivators from section_12 ----------- 
          const motivators = response.section_12.title || [];
          const motivatorsArray = motivators.map((motivator, index) => ({
            id: index + 1, // Assign a unique id
            name: motivator,
          }));
          setWorkMotivators(motivatorsArray);

          // Set work motivators comment
          const comment = response.section_12.comments || '';
          setWorkMotivatorsComment(comment); 
          console.log('workMotivatorsComment====>>', workMotivatorsComment);
          
          formik.setFieldValue('workMotivatorsComment', comment); // Set formik value
          //!----------- Set work motivators from section_12 ----------- 

          setShowName(response.section_1.team_member_name)
          if (user_id == response.section_1.team_member_id) {
            setShowName(response.section_1.supervisor_name)
          }

          formik.setFieldValue(`conversationId`, response.section_1._id);
          formik.setFieldValue(`team_member_name`, response.section_1.team_member_name);
          formik.setFieldValue(`supervisor_name`, response.section_1.supervisor_name);
          formik.setFieldValue(`supervisor_id`, response.section_1.supervisor_id);
          formik.setFieldValue(`team_member_id`, response.section_1.team_member_id);
          formik.setFieldValue(`date`, response.section_1.date);
          formik.setFieldValue(`year`, response.section_1.year);
          formik.setFieldValue(`notes`, response.section_1.notes);


          //* ------------ new chnages by suraj 26-11-2024 -------------------------
          formik.setFieldValue(`most_proud`, response.section_1.most_proud);
          formik.setFieldValue(`whats_working_title`, response.section_1.whats_working_title);
          formik.setFieldValue(`whats_not_working_title`, response.section_1.whats_not_working_title);
          formik.setFieldValue(`next_steps_title`, response.section_1.next_steps_title);
          formik.setFieldValue(`provide_feedback_title`, response.section_1.provide_feedback_title);
          formik.setFieldValue(`improve_personally_professionally_title`, response.section_1.improve_personally_professionally_title);
          //! ------------ new chnages by suraj 26-11-2024 -------------------------


          formik.setFieldValue(`strengths_and_accomplishments`, response.section_1.strengths_and_accomplishments);
          formik.setFieldValue(`performance_areas_which_need_improvement`, response.section_1.performance_areas_which_need_improvement);
          formik.setFieldValue(`plan_of_action_toward_improved_performance`, response.section_1.plan_of_action_toward_improved_performance);
          formik.setFieldValue(`employee_comments`, response.section_1.employee_comments);
          formik.setFieldValue(`whats_working`, response.section_1.whats_working);


          // formik.setFieldValue(`employee_date`, response.section_1.employee_date);


          const currentDate = new Date().toISOString().split('T')[0];
          if (response.section_1.employee_sign == 'Y') {
            formik.setFieldValue(`employee_date`, response.section_1.employee_date);
            setEmployeeSign(true)
          } else {
            formik.setFieldValue('employee_date', currentDate);
          }

          if (response.section_1.evaluated_by_sign == 'Y') {
            formik.setFieldValue(`evaluated_by_date`, response.section_1.evaluated_by_date);
            setEvaluatedBySign(true)
          } else {
            // Format: 'YYYY-MM-DD'

            // Set the field value using Formik
            formik.setFieldValue('evaluated_by_date', currentDate);
          }

          // formik.setFieldValue(`employee`, response.section_1.employee);
          formik.setFieldValue(`employee`, response.section_1.team_member_name);


          // formik.setFieldValue(`evaluated_by`, response.section_1.evaluated_by);
          formik.setFieldValue(`evaluated_by`, response.section_1.supervisor_name);

          // formik.setFieldValue(`evaluated_by_date`, response.section_1.evaluated_by_date);
          formik.setFieldValue(`witnessed_by_date`, response.section_1.witnessed_by_date);
          formik.setFieldValue(`witnessed_by`, response.section_1.witnessed_by);

          formik.setFieldValue(`employee_sign`, response.section_1.employee_sign);
          formik.setFieldValue(`evaluated_by_sign`, response.section_1.evaluated_by_sign);
          formik.setFieldValue(`witnessed_by_sign`, response.section_1.witnessed_by_sign);

          formik.setFieldValue(`signature2`, response.section_1.signature2);
          formik.setFieldValue(`signature3`, response.section_1.signature3);


          formik.setFieldValue(`human_resources`, response.section_1.human_resources);
          formik.setFieldValue(`human_resources_notes`, response.section_1.human_resources_notes);
          formik.setFieldValue(`vp_construction`, response.section_1.vp_construction);
          formik.setFieldValue(`vp_construction_notes`, response.section_1.vp_construction_notes);
          formik.setFieldValue(`president`, response.section_1.president);
          formik.setFieldValue(`president_notes`, response.section_1.president_notes);

          formik.setFieldValue(`supervisor_status`, response.section_1.supervisor_status);
          formik.setFieldValue(`supervisor_notes`, response.section_1.supervisor_notes);

          //* -----------------------------

          if (response.section_2.length != 0) {
            formik.setFieldValue(`section_2`, response.section_2);
            setSection1Array(response.section_2);
          }

          //* ---------------------------------------------------------
          if (response.section_3.length != 0) {
            formik.setFieldValue(`section_3`, response.section_3);
            setSection2Array(response.section_3);
          }
          if (response.section_4.length != 0) {
            formik.setFieldValue(`section_4`, response.section_4);
            setSection3Array(response.section_4);
          }
          if (response.section_5.length != 0) {
            formik.setFieldValue(`section_5`, response.section_5);
            setSection4Array(response.section_5);
          }
          // if (response.section_6.length != 0) {
          //   formik.setFieldValue(`section_6`, response.section_6);
          // }

          //* ---------------------------------------------------------
          if (response.section_6.length !== 0) {
            formik.setFieldValue(`section_6`, response.section_6);

            console.log('....>>', formik.values.section_6[0].measurables_comments);
            console.log('.xx...>>', response.section_6[0].my_total_q1_comment);


            // Check if measurables_comments is empty
            if (response.section_6[0].measurables_comments === '') {
              // Set measurables_comments to the combined total comments
              formik.setFieldValue(`section_6.0.measurables_comments`, formik.values.section_6[0].measurables_comments);

            }
          }

          //* ---------------------------------------------------------
          if (response.section_7.length != 0) {
            formik.setFieldValue(`section_7`, response.section_7);
          }
          if (response.section_8.length != 0) {
            formik.setFieldValue(`section_8`, response.section_8);
          }
          if (response.section_9.length != 0) {
            formik.setFieldValue(`section_9`, response.section_9);
          }
          if (response.section_10.length != 0) {
            formik.setFieldValue(`section_10`, response.section_10);
          }
          if (response.section_11.length != 0) {
            formik.setFieldValue(`section_11`, response.section_11);
          }
          //! ---------------------------------------------------------

          if (response.hasOwnProperty('quater_3')) {
            formik.setFieldValue(`quater_3`, response.quater_3);
            // setSection1Array(response.quater_1);

          }
          // if (response.quater_1.length != 0) {
          if (response.hasOwnProperty('quater_1')) {
            formik.setFieldValue(`quater_1`, response.quater_1);
            // setSection1Array(response.quater_1);
          }
          if (response.hasOwnProperty('quater_2')) {
            formik.setFieldValue(`quater_2`, response.quater_2);
          }

          //* ------------------
          let coreVal = [];
          if (response.hasOwnProperty('core_1')) {
            coreVal = [...response.core_1];
            formik.setFieldValue(`core_1`, response.core_1);
          }
          if (response.hasOwnProperty('core_2')) {
            coreVal = [...response.core_2];

            formik.setFieldValue(`core_2`, response.core_2);
          }

          if (response.hasOwnProperty('core_3')) {
            coreVal = [...response.core_3];
            formik.setFieldValue(`core_3`, response.core_3);
          }

          let corVal = [];
          for (var item of coreVal) {
            const userFound = corVal.find(user => user['description'] === item['description']);

            if (!userFound) {
              corVal.push(item);
            }
          }
          if (corVal.length == 0) {
            corVal.push({ description: '', title: '' })
          }
          formik.setFieldValue(`core_5`, corVal);
          /// 

          console.log("coreVal", corVal);
          //! ------------------




          //* ------purpose------------

          let purposeVal = [];

          if (response.hasOwnProperty('purpose_3')) {
            purposeVal = [...purposeVal, ...response.purpose_3];
            formik.setFieldValue(`purpose_3`, response.purpose_3);
          }

          if (response.hasOwnProperty('purpose_2')) {
            purposeVal = [...purposeVal, ...response.purpose_2];

            formik.setFieldValue(`purpose_2`, response.purpose_2);
          }

          if (response.hasOwnProperty('purpose_1')) {
            purposeVal = [...purposeVal, ...response.purpose_1];
            formik.setFieldValue(`purpose_1`, response.purpose_1);
          }


          let purposVal = [];
          for (var item3 of purposeVal) {
            const userFound = purposVal.find(user => user['description'] === item3['description']);

            if (!userFound) {
              purposVal.push(item3);

            }
          }
          if (purposVal.length == 0) {
            purposVal.push({ description: '', title: '' })
          }
          formik.setFieldValue(`purpose_5`, purposVal);

        }
      })
  };
  //! --------------------------------------------------

  //? --------------------------------------------------

  const headerStyle = {
    background: "#FEC025",
    border: "1px solid #E9ECEF",
    textAlign: "center",
    fontSize: "14px",
  };

  const cellStyle = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
  };

  const cellStylec = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    textAlign: 'center',
  };

  const cellStyleh = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    textAlign: 'center',
    height: '40px'
  };

  const cellStylee = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    textAlign: 'end',
  };

  const cellStyleW = {
    border: "1px solid #E9ECEF",
    backgroundColor: 'white',
    paddingTop: '5px'

  };

  const yesCellStyle = {
    ...cellStyle,
  };

  const dropdownCellStyle = {
    ...yesCellStyle,
    padding: "0",
  };

  //? --------------------------------------------------

  const renderTextAreaFull = (fieldName, placeholder, formData = '', rowCount = 2, disabled = false) => (
    <InputTextarea
      disabled={disabled}
      placeholder={placeholder}
      name={fieldName}
      rows={rowCount}
      autoResize
      id={fieldName}
      value={formData !== '' ? formData : formik.values[fieldName]}

      onChange={(e) => {
        console.log(e.target.value)
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{
        width: '100%',
        boxSizing: 'border-box',
        border: 'none',
        outline: 'none',
        fontSize: '14px',
        color: '#495057',
        display: 'flex',
        alignItems: 'center',
        paddingTop: '8px',
        padding: '4px'
      }}
    ></InputTextarea>
  );

  // const renderTextAreaFullDD = (fieldName, placeholder, formData = '', rowCount = 2,) => (
  //   <InputTextarea
  //     disabled={true}
  //     placeholder={placeholder}
  //     name={fieldName}
  //     rows={rowCount}
  //     autoResize
  //     id={fieldName}
  //     value={formData !== '' ? formData : formik.values[fieldName]}
  //     className='px-4'
  //     onChange={(e) => {

  //       formik.setFieldValue(fieldName, e.target.value)
  //     }}
  //     style={{
  //       width: '100%',
  //       boxSizing: 'border-box',
  //       border: 'none',
  //       outline: 'none',
  //       fontSize: '16px',
  //       color: '#495057',
  //       display: 'flex',
  //       alignItems: 'center',
  //       paddingTop: '8px',
  //       padding: '4px'
  //     }}
  //   ></InputTextarea>
  // );

  const renderTextAreaFullDD = (fieldName, placeholder, formData = '', rowCount = 2) => {
    // Replace \\n with \n in formData and formik.values[fieldName]
    const value = (formData && typeof formData === 'string' ? formData.replace(/\\n/g, ' \n') : '') ||
      (formik.values[fieldName] && typeof formik.values[fieldName] === 'string' ? formik.values[fieldName].replace(/\\n/g, '\n') : '');

    console.log('value===>>', value);


    return (
      <InputTextarea
        disabled={true}
        placeholder={placeholder}
        name={fieldName}
        rows={rowCount}
        autoResize
        id={fieldName}
        value={value} // Use the processed value
        className='px-4'
        onChange={(e) => {
          formik.setFieldValue(fieldName, e.target.value);
        }}
        style={{
          width: '100%',
          boxSizing: 'border-box',
          border: 'none',
          outline: 'none',
          fontSize: '16px',
          color: '#495057',
          display: 'flex',
          alignItems: 'center',
          paddingTop: '8px',
          padding: '4px'
        }}
      />
    );
  };

  const renderTextAreaFullMeasurables = (fieldName, placeholder, formData = '', rowCount = 2, disabled = false) => (
    <InputTextarea
      disabled={disabled}
      placeholder={placeholder}
      name={fieldName}
      rows={rowCount}
      autoResize
      id={fieldName}
      // value={formData !== '' ? formData : formik.values[fieldName]}
      // value={formData}
      value={formik.values.section_6[0].measurables_comments.split('\n').slice(0, 3).join('\n')}
      className='px-4'
      onChange={(e) => {

        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{
        width: '100%',
        boxSizing: 'border-box',
        border: 'none',
        outline: 'none',
        fontSize: '16px',
        color: '#495057',
        display: 'flex',
        alignItems: 'center',
        paddingTop: '8px',
        padding: '4px'
      }}
    ></InputTextarea>
  );

  const renderTextAreaFullTT = (fieldName, placeholder, formData = '', rowCount = 2, disabled = false) => (
    <InputTextarea
      placeholder={placeholder}
      name={fieldName}
      rows={rowCount}
      autoResize
      id={fieldName}
      value={formData !== '' ? formData : formik.values[fieldName]}
      disabled
      onChange={(e) => {
        console.log(e.target.value)
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{
        width: '100%',
        boxSizing: 'border-box',
        border: 'none',
        outline: 'none',
        fontSize: '16px',
        color: '#495057',
        display: 'flex',
        alignItems: 'center',
        paddingTop: '8px',
        padding: '4px',
        marginTop: '8px'
      }}
    ></InputTextarea>
  );

  const renderTextAreaFullYY = (fieldName, placeholder, formData = '', rowCount = 2, disabled = false) => (
    <InputTextarea
      disabled={disabled}
      placeholder={placeholder}
      name={fieldName}
      rows={rowCount}
      autoResize
      id={fieldName}
      value={formData !== '' ? formData : formik.values[fieldName]}

      onChange={(e) => {
        console.log(e.target.value)
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{
        width: '100%',
        boxSizing: 'border-box',
        border: '0.5px solid #DCE4C9',
        outline: 'none',
        fontSize: '14px',
        color: '#495057',
        display: 'flex',
        alignItems: 'center',
        paddingTop: '8px',
        padding: '4px'
      }}
    ></InputTextarea>
  );

  const renderTextAreaFullComments = (fieldName, placeholder, formData = '', rowCount = 2, disabled = false) => (
    <InputTextarea
      disabled={disabled}
      placeholder={placeholder}
      name={fieldName}
      rows={rowCount}
      autoResize
      id={fieldName}
      value={formData !== '' ? formData : formik.values[fieldName]}

      onChange={(e) => {
        console.log(e.target.value)
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: '2px solid #80C4E9', outline: 'none', fontSize: '14px', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', padding: '4px', }}
    ></InputTextarea>
  );


  const renderSlider = (fieldName, formData = '',) => (
    <div className='' style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingLeft: '10px', paddingRight: '10px', }}>
      <Slider
        value={formData !== '' ? formData : formik.values[fieldName]}
        onChange={(e) => {
          console.log('Slider value:', e.value);
          formik.setFieldValue(fieldName, e.value)
        }}
        min={1}
        max={5}
        // step={1} 
        style={{ width: '100%' }}
      />
      <div style={{ marginTop: '10px', fontSize: '14px' }}>
        {formData !== '' ? formData : formik.values[fieldName]}
      </div>
    </div>
  );


  const renderInputArea = (fieldName, placeholder = '', type = 'text', formData = '', disabled = false,) => (

    <input
      type={type}
      disabled={disabled}
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      step="any"
      value={formData !== '' ? formData : formik.values[fieldName]}
      onChange={(e) => { formik.setFieldValue(fieldName, e.target.value) }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
      style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px', fontSize: '14px', textAlign: 'center', marginTop: '0px', }}

    />
  );

  const renderInputAreaUptoTen = (fieldName, placeholder = '', type = 'number', formData = '', disabled = false) => (
    <input
      type={type}
      disabled={disabled}
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      step="1" // Allows only integer values
      min="0" // Minimum value
      max="10" // Maximum value
      value={formData !== '' ? formData : formik.values[fieldName]}
      onChange={(e) => {
        const value = e.target.value;
        // Validate the input value
        if (value === '' || (value >= 0 && value <= 10)) {
          formik.setFieldValue(fieldName, value);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
      style={{
        width: '100%',
        height: '40px',
        boxSizing: 'border-box',
        border: '2px solid #DCE4C9',
        borderRadius: '0px',
        fontSize: '14px',
        textAlign: 'center',
        marginTop: '0px'
      }}
    />
  );



  const renderPercentageInputArea = (fieldName, formData = '') => (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <InputNumber
        value={formData != '' ? formData : formik.values[fieldName]}
        className="text-center"
        inputClassName={Number(formik.values[fieldName]) < 0 ? "is-negative" : "is-positive"}
        placeholder="0.00"
        maxFractionDigits={2}
        onChange={(e) => {

          formik.setFieldValue(fieldName, e.value)
        }}
        suffix="%"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault(); // Prevent form submission on Enter key press
          }
        }}
        style={{
          width: "100%",
          height: "40px",
          boxSizing: "border-box",
          border: "none",
          fontSize: "14px",
          textAlign: "center !important",
          marginTop: "0px",

        }}
      />
    </div>
  );

  const renderSelect = (fieldName, formdata = '') => {
    var val = (formdata != '') ? formdata : formik.values[fieldName];

    if (val == undefined) {
      val = 'N'
    }
    return <select
      name={fieldName}
      id={fieldName}
      className={'select-text-color-' + val}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      onChange={(e) => {
        formik.setFieldValue(fieldName, e.target.value);
      }}
      style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '14px', color: 'white', backgroundColor: '#ff0000', border: 'none' }}
    >
      <option value="N">No</option>
      <option value="Y">Yes</option>
      <option value="NA">NA</option>
    </select>
  };

  const renderSelect2 = (fieldName, formdata = '') => {
    var val = (formdata != '') ? formdata : formik.values[fieldName];

    if (val == undefined) {
      val = 'N'
    }
    return <select
      name={fieldName}
      id={fieldName}
      // className={'select-text-color-' + val}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      onChange={(e) => {
        formik.setFieldValue(fieldName, e.target.value);
      }}
      style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '14px', color: 'Black', backgroundColor: 'transparent', border: 'none' }}
    >
      <option value="minus">-</option>
      <option value="plus">+</option>
      <option value="both">+/-</option>
    </select>
  };

  const renderSelectDone = (fieldName, formdata = '', disabled = false) => {
    var val = (formdata != '') ? formdata : formik.values[fieldName];

    if (val == undefined) {
      val = 'N'
    }
    return <select
      name={fieldName}
      id={fieldName}
      disabled={disabled}
      className={'select-text-color-' + val}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      onChange={(e) => {
        formik.setFieldValue(fieldName, e.target.value);
      }}
      style={{ width: '100%', textAlign: 'center', height: "46px", fontSize: '14px', color: 'white', backgroundColor: '#ff0000', border: 'none' }}
    >
      <option value="N">Off Track</option>
      <option value="NA">On Track</option>
      <option value="Y">Done</option>
    </select>
  };

  const renderYearSelect = (fieldName, formdata = '') => {
    const currentYear = new Date().getFullYear(); // Get the current year
    var val = (formdata !== '') ? formdata : formik.values[fieldName];
    if (val === undefined) {
      val = currentYear; // Default to the current year
    }

    const years = [];
    for (let year = 2020; year <= 2030; year++) {
      years.push(year);
    }

    return (
      <select
        name={fieldName}
        id={fieldName}
        value={formdata !== '' ? formdata : formik.values[fieldName]}
        onChange={(e) => {
          formik.setFieldValue(fieldName, e.target.value);
        }}
        style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '14px', color: 'Black', font: 'bold', backgroundColor: '#EEEEEE', border: 'none' }}
      >
        <option selected disabled value=''></option>
        {years.map(year => (
          <option key={year} value={year}>{year}</option>
        ))}
      </select>
    );
  };
  // ----------------------------------------------------------------------------
  const toast = useRef(null);
  // ----------------------------------------------------------------------------
  const handleAddInputForSection1Array = () => {
    setSection1Array([...Section1Array, { name: '', }]);

    formik.values.section_2.push({
      title: '',
      description: '',
    });

  };

  const handleDeleteInputForSection1Array = (index) => {
    setSection1Array([...Section1Array, { name: '', }]);
    const newArray = [...Section1Array];
    newArray.splice(index, 1);
    formik.values.section_2.splice(index, 1);
    setSection1Array(newArray);
  };



  const handleAddInputForSection4Array = () => {
    setSection4Array([...Section4Array, { name: '', }]);
    formik.values.section_5.push({
      title: '',
      description: '',
    });
  };

  const handleDeleteInputForSection4Array = (index) => {
    setSection4Array([...Section4Array, { name: '', }]);
    const newArray = [...Section4Array];
    newArray.splice(index, 1);
    formik.values.section_5.splice(index, 1);
    setSection4Array(newArray);
  };
  // ----------------------------------------------------------------------------


  const supervisorDropdown = () => {
    return (<Dropdown
      optionValue='user_id'
      id="supervisor_id"
      name="supervisor_id"
      placeholder="Select a Supervisor"
      options={allSupervisors}
      optionLabel={(e) => { return e.first_name + ' ' + e.last_name }}
      value={formik.values.supervisor_id}
      className='p-2'
      style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '14px', color: 'white', border: 'none' }}
      onChange={(e) => {
        var sp = allSupervisors.find((s) => s.user_id === e.value)
        if (sp) {
          formik.setFieldValue('supervisor_name', sp.first_name + ' ' + sp.last_name)
          console.log('hhhhhhhhhh-', formik.values.supervisor_name);
        }
        formik.setFieldValue('supervisor_id', e.value);
      }}
    />
    );
  }

  //* ------------------------------------
  const ccDropdowng = () => {
    return (
      <MultiSelect value={selectedCCList} onChange={(e) => {

        setSelectedCCList(e.value)

        console.log(selectedCCList)


        // formik.setFieldValue('cc_users', e.value[0].user_id)
      }} options={allSupervisors} optionLabel={(e) => { return e.first_name + ' ' + e.last_name + ' - ' + e.role_name }} display="chip" filter
        placeholder="Select CC" className="m-2 p-2 w-full mutiii" />
    );
  };
  //! ------------------------------------
  //* ------------------Signature------------------
  const [isSignatureModalVisible, setSignatureModalVisible] = useState(false);
  const [signatureImage, setSignatureImage] = useState(null);

  const handleSignatureSave = (image) => {
    setSignatureImage(image);
    // You can also set this in formik if needed
    formik.setFieldValue('evaluated_by_sign', image);
  };

  const signatureModalOpen = () => {
    setSignatureModalVisible(true)
  }
  //! ------------------------------------
  //! ------------------------------------
  const [workMotivators, setWorkMotivators] = useState([]);
  const [workMotivatorsComment, setWorkMotivatorsComment] = useState('');


  const itemTemplate = (item) => {
    let index = workMotivators.indexOf(item);
    // console.log('index-->', index)
    return (
      <div className="flex flex-wrap p-2 align-items-center gap-3">
        <div className="flex py-2  gap-4 xl:mr-8">
          < strong>{index + 1}</strong>
          < span>{item.name}</span>
        </div>
      </div>
    );
  };


  //! ------------------------------------
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);;
  const [evaluatedBySign, setEvaluatedBySign] = useState(false);;
  const [employeeSign, setEmployeeSign] = useState(false);;

  //! ------------------------------------
  const user_id = localStorage.getItem('user_id');
  const team_member_id = formik.values.team_member_id; // Assuming this is set from the API response
  const supervisor_id = formik.values.supervisor_id; // Assuming this is set from the API response

  const canSignAsEmployee = team_member_id === user_id;
  const canSignAsSupervisor = supervisor_id === user_id;
  //! ------------------------------------

  return (

    <>
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="form-container" style={{ padding: '10px' }}>
          <form onSubmit={openSavePopup}>
            <Toast ref={toast} />
            <div className='form-box' >
              <div className="bg-yellow-200 flex justify-between py-2 px-4 sticky-header " style={{ position: 'ticky', top: 0, alignItems: 'center' }} >
                <button type='button' onClick={() => { navigate(-1); window.close(); }} className='customSave-button m-2 flex'>
                  <IoArrowBackSharp className='' />
                  <span >Back</span>
                </button>

                <div className="mx-auto">
                  <h2 className="main-title-font">Annual Performance Review</h2>
                </div>
                <div >
                  <Button
                    className='p-2 px-3 m-2 customSave-button '
                    title='Save'
                    loading={saveLoading}
                    type='button'
                    onClick={directSave}
                    disabled={isSaveDisabled}
                  >
                    <span>Save</span>
                  </Button>
                </div>

                <div >
                  <Button
                    className='p-2 px-3 m-2 copySave-button '
                    title='Save And Send Message'
                    loading={saveLoading}
                    disabled={isSaveDisabled}
                  >
                    <span>Send Message</span>
                  </Button>
                </div>
              </div>

              <div className="items-center justify-center h-screen">

                {/* --------First------------- */}
                <div>
                  <table style={{ borderCollapse: "collapse", width: "auto", display: "flex", justifyContent: "center" }} className='m-4' >
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, minWidth: "300px", }} >
                          Team Member Name:
                        </td>
                        <td style={{ ...cellStyle, minWidth: "350px" }} >
                          {renderInputArea('team_member_name', 'Team Member Name', 'text', '', true)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ ...cellStyle, minWidth: "300px", }} >
                          Supervisor Name:
                        </td>
                        <td style={{ ...cellStyle, minWidth: "350px" }} >
                          {formik.values.is_supervisor == true ? supervisorDropdown() : renderInputArea('supervisor_name', 'Supervisor Name', 'text', '', true)}

                        </td>
                      </tr>
                      <tr>
                        <td style={{ ...cellStyle, minWidth: "300px", }} >
                          Date:
                        </td>
                        <td style={{ ...cellStyle, minWidth: "350px" }} >
                          {renderInputArea('date', '', 'date')}
                        </td>
                      </tr>

                      <tr>
                        <td style={{ ...cellStyle, minWidth: "300px", }} >
                          Year
                        </td>
                        <td style={{ ...cellStyle, minWidth: "300px", padding: 0 }} >
                          {renderYearSelect('year')}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                  <div className='px-1 py-3'>
                    <p className="mt-2 paragraph"><strong>NOTE: PLEASE COMPLETE THE FOLLOWING AREAS:</strong> Your Goals, the LIDA Homes Core Values, your Roles and Responsibilities, your Measurables, the People Analyzer/GWC, and the Delegate/Elevate exercise (annually). Please then rate the culture and your job satisfaction, and bring this document to your Quarterly Conversation.</p>

                  </div>

                </div>

                {/* //* 1------- Rocks Start------------ */}
                {/* //? ------- Rocks Q4------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <h2 className="form-title-font">Rocks Q4</h2>
                </div>
                <div className="px-0 py-3">
                  <h3 className="subtitle-font  mb-3">
                    Your 1-5 Goals are. How are they going? Are you on track or off track?
                  </h3>
                  <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                    <thead>
                    </thead>
                    <tbody>
                      {Section1Array.map((item, key) => (
                        <tr key={key}>
                          <td style={{ ...cellStyleW, width: '100px' }}>
                            {renderInputArea(`section_2.${key}.title`, '', 'text', formik.values.section_2[key].title)}
                          </td>
                          <td style={{ ...cellStyleW, minWidth: "600px" }}>
                            {renderTextAreaFull(`section_2.${key}.description`, '', formik.values.section_2[key].description, 2)}
                          </td>
                          <td style={{ ...cellStyleW, width: "100px" }}>
                            {renderSelectDone(`section_2.${key}.rocks_done`, formik.values.section_2[key].rocks_done)}
                          </td>

                          <td style={{ ...cellStyleW, width: '100px' }}>

                            {key != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection1Array(key)} />) : null}

                            {Section1Array.length - 1 == key ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection1Array()} />) : null}

                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* //? ------- Rocks Q3------------ */}
                {formik.values.quater_3 && formik.values.quater_3.length > 0 && (
                  <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                    <h2 className="form-title-font">Rocks Q3</h2>
                  </div>
                )}
                {formik.values.quater_3 && formik.values.quater_3.length > 0 && (
                  <div className="px-0 py-3">
                    <h3 className="subtitle-font mb-3">
                      Your 1-5 Goals are. How are they going? Are you on track or off track?
                    </h3>
                    <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                      <thead>
                      </thead>
                      <tbody>
                        {formik.values.quater_3.map((item, key) => formik.values.quater_3[key].description == '' ? null : (
                          <tr key={key}>
                            <td style={{ ...cellStyleW, width: '100px' }}>
                              {renderInputArea(`quater_3.${key}.title`, '', 'text', formik.values.quater_3[key].title)}
                            </td>
                            <td style={{ ...cellStyleW, minWidth: "600px" }}>
                              {renderTextAreaFull(`quater_3.${key}.descriptionquater_1.${key}.description`, '', formik.values.quater_3[key].description, 2, true)}
                            </td>
                            <td style={{ ...cellStyleW, width: "100px" }}>
                              {renderSelectDone(`quater_3.${key}.rocks_done`, formik.values.quater_3[key].rocks_done, true)}
                            </td>
                            <td style={{ width: '100px' }}>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* //? ------- Rocks Q2------------ */}
                {formik.values.quater_2 && formik.values.quater_2.length > 0 && (
                  <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                    <h2 className="form-title-font">Rocks Q2</h2>
                  </div>
                )}
                {formik.values.quater_2 && formik.values.quater_2.length > 0 && (
                  <div className="px-0 py-3">
                    <h3 className="subtitle-font mb-3">
                      Your 1-5 Goals are. How are they going? Are you on track or off track?
                    </h3>
                    <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                      <thead>
                      </thead>
                      <tbody>
                        {formik.values.quater_2.map((item, key) => formik.values.quater_2[key].description == '' && null ? null : (
                          <tr key={key}>
                            <td style={{ ...cellStyleW, width: '100px' }}>
                              {renderInputArea(`quater_2.${key}.title`, '', 'text', formik.values.quater_2[key].title)}
                            </td>
                            <td style={{ ...cellStyleW, minWidth: "600px" }}>
                              {renderTextAreaFull(`quater_2.${key}.descriptionquater_1.${key}.description`, '', formik.values.quater_2[key].description, 2, true)}
                            </td>
                            <td style={{ ...cellStyleW, width: "100px" }}>
                              {renderSelectDone(`quater_2.${key}.rocks_done`, formik.values.quater_2[key].rocks_done, true)}
                            </td>
                            <td style={{ width: '100px' }}>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* //? ------- Rocks Q1------------ */}
                {formik.values.quater_1 && formik.values.quater_1.length > 0 && (
                  <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                    <h2 className="form-title-font">Rocks Q1</h2>
                  </div>
                )}
                {formik.values.quater_1 && formik.values.quater_1.length > 0 && (
                  <div className="px-0 py-3">
                    <h3 className="subtitle-font mb-3">
                      Your 1-5 Goals are. How are they going? Are you on track or off track?
                    </h3>
                    <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                      <thead>
                      </thead>
                      <tbody>
                        {formik.values.quater_1.map((item, key) => formik.values.quater_1[key].description == '' ? null : (
                          <tr key={key}>
                            <td style={{ ...cellStyleW, width: '100px' }}>
                              {renderInputArea(`quater_1.${key}.title`, '', 'text', formik.values.quater_1[key].title)}
                            </td>
                            <td style={{ ...cellStyleW, minWidth: "600px" }}>
                              {renderTextAreaFull(`quater_1.${key}.descriptionquater_1.${key}.description`, '', formik.values.quater_1[key].description, 2, true)}
                            </td>
                            <td style={{ ...cellStyleW, width: "100px" }}>
                              {renderSelectDone(`quater_1.${key}.rocks_done`, formik.values.quater_1[key].rocks_done, true)}
                            </td>
                            <td style={{ width: '100px' }}>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* //! 1------- Rocks ------------ */}

                {/* //* 2------- Purpose ------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4 '>
                  <h2 className="form-title-font">
                    Purpose
                  </h2>
                </div>
                <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                  <h4 className="subtitle-font mb-3">
                    Why do we do what we do?
                  </h4>
                  <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                    <thead>

                    </thead>
                    <tbody>

                      <td style={{ ...cellStyleW, minWidth: "600px", padding: '10px' }}>
                        Creating a "WOW" Experience for our Team and Clients.
                      </td>

                    </tbody>
                  </table>
                  <div className='flex  mt-4' style={{ alignItems: 'center', gap: '20px' }}>
                    <p>Are you embracing the companies purpose?</p>
                    <div style={{ width: '100px' }}>
                      {renderSelect('section_4.0.embracing_core_values', formik.values.section_4[0].embracing_core_values)}
                    </div>
                  </div>
                </div>
                {/* //! 2------- Purpose ------------ */}


                {/* //* 3------- Core Values ------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <h2 className="form-title-font">Core Values</h2>
                </div>
                <div className="px-0 py-3" >
                  <h4 className="subtitle-font mb-3">
                    The 3 LIDA Construction Core Values, we hire, fire and promote on them.
                  </h4>
                  <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                    <thead>

                    </thead>
                    <tbody>

                      <tr className='' style={{ display: 'block' }}>
                        <td style={{ ...cellStyleW, minWidth: "600px", padding: '10px', display: 'block' }}>
                          We Are Committed to Excellence in all that we do.
                        </td>
                        <td style={{ ...cellStyleW, minWidth: "600px", padding: '10px', display: 'block' }}>
                          We Do What We Say We Are Going To Do
                        </td>
                        <td style={{ ...cellStyleW, minWidth: "600px", padding: '10px', display: 'block' }}>
                          We Are the ultimate Team Players
                        </td>
                      </tr>

                    </tbody>
                  </table>

                  <div className='flex  mt-4' style={{ alignItems: 'center', gap: '20px' }}>
                    <p >Are you embracing the companies Core Values? </p>
                    <div style={{ width: '100px' }}>
                      {renderSelect('section_3.0.embracing_core_values', formik.values.section_3[0].embracing_core_values)}
                    </div>
                  </div>


                </div>
                {/* //! 3------- Core Values ------------ */}

                {/* //*------- The People Analyzer ------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <h2 className="form-title-font">
                    The People Analyzer
                  </h2>
                </div>
                <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", width: "auto" }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, }} >

                        </th>
                        <th style={{ ...headerStyle }} colSpan={3} >
                          Company Core Values
                        </th>
                        <th style={{ ...headerStyle }} colSpan={3} >
                          Current job responsibilities
                        </th>
                      </tr>
                      <tr>
                        <th style={{ ...headerStyle, minWidth: "500px", }} >
                          Name (Rate yourself first)
                        </th>
                        <th style={{ ...headerStyle, width: "200px" }} >
                          Teamwork
                        </th>
                        <th style={{ ...headerStyle, width: "200px" }} >
                          Committed To Excellence
                        </th>
                        <th style={{ ...headerStyle, width: "200px" }} >
                          We Always do What we Say We are Going to do
                        </th>
                        <th style={{ ...headerStyle, width: "200px" }} >
                          Gets It Yes/No
                        </th>
                        <th style={{ ...headerStyle, width: "200px" }} >
                          Wants It Yes/No
                        </th>
                        <th style={{ ...headerStyle, width: "200px" }} >
                          Has the Capacity to do it Yes/No
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} >
                          {renderInputArea(`section_8.0.name`, '', 'text', formik.values.section_8[0].name)}
                        </td>

                        <td style={{ ...cellStyle, }} >
                          {renderSelect2(`section_8.0.teamwork`, formik.values.section_8[0].teamwork)}
                        </td>
                        <td  >
                          {renderSelect2(`section_8.0.committed_to_excellence`, formik.values.section_8[0].committed_to_excellence)}
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect2(`section_8.0.we_always_do`, formik.values.section_8[0].we_always_do)}
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_8.0.gets_it`, formik.values.section_8[0].gets_it)}
                        </td>

                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_8.0.wants_it`, formik.values.section_8[0].wants_it)}
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_8.0.has_the_capacity`, formik.values.section_8[0].has_the_capacity)}
                        </td>
                      </tr>

                      <tr>
                        <td style={{ ...cellStyle, }} >
                          {renderInputArea(`section_8.1.name`, '', 'text', formik.values.section_8[1].name)}
                        </td>

                        <td style={{ ...cellStyle, }} >
                          {renderSelect2(`section_8.1.teamwork`, formik.values.section_8[1].teamwork)}
                        </td>
                        <td  >
                          {renderSelect2(`section_8.1.committed_to_excellence`, formik.values.section_8[1].committed_to_excellence)}
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect2(`section_8.1.we_always_do`, formik.values.section_8[1].we_always_do)}
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_8.1.gets_it`, formik.values.section_8[1].gets_it)}
                        </td>

                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_8.1.wants_it`, formik.values.section_8[1].wants_it)}
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_8.1.has_the_capacity`, formik.values.section_8[1].has_the_capacity)}
                        </td>
                      </tr>

                      <tr>
                        <td style={{ ...cellStyle, }} >
                          {renderInputArea(`section_8.2.name`, '', 'text', formik.values.section_8[2].name)}
                        </td>

                        <td style={{ ...cellStyle, }} >
                          {renderSelect2(`section_8.2.teamwork`, formik.values.section_8[2].teamwork)}
                        </td>
                        <td  >
                          {renderSelect2(`section_8.2.committed_to_excellence`, formik.values.section_8[2].committed_to_excellence)}
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect2(`section_8.2.we_always_do`, formik.values.section_8[2].we_always_do)}
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_8.2.gets_it`, formik.values.section_8[2].gets_it)}
                        </td>

                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_8.2.wants_it`, formik.values.section_8[2].wants_it)}
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_8.2.has_the_capacity`, formik.values.section_8[2].has_the_capacity)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='px-4 py-2' style={{ marginTop: '25px' }}>
                    <strong> Ratings:  </strong> + l +/- l -
                    <p className='py-2'>+ = 80% - 100%</p>

                    <p className='py-2'> +/- = 60% - 80%</p>

                    <p className='py-2'> - = less than 60% The bar is 80% </p>

                  </div>
                </div>
                {/* //!------- The People Analyzer ------------ */}

                {/* //*  4------- Roles & Responsibility --------- */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <h2 className="form-title-font">
                    Roles & Responsibility
                  </h2>
                </div>
                <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                  <h4 className="subtitle-font mb-3">
                    Your 5-7 Roles and Responsibilities. Do you understand your roles and responsibilities? Do you need to add or delete any?
                  </h4>
                  <h4 className='title-font'>
                    1 - Unacceptable
                  </h4>
                  <h4 className='title-font'>
                    2 - Need Improvement
                  </h4>
                  <h4 className='title-font'>
                    3 - Meet Expectations
                  </h4>
                  <h4 className='title-font'>
                    4 - Exceeds Expectations
                  </h4>
                  <h4 className='title-font'>
                    5 - Outstanding
                  </h4>

                  <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, }} >
                        </th>
                        <th style={{ ...headerStyle, }} >
                        </th>
                        <th style={{ ...headerStyle, }} >
                          Self Score
                        </th>
                        <th style={{ ...headerStyle, }} >
                          Supervisor Score
                        </th>
                        <th style={{ ...headerStyle, }} >
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {Section4Array.map((item, index) => (
                        <>

                          <tr key={index}>

                            <td style={{ ...cellStyleW, width: '100px', textAlign: 'center' }}>
                              {/* {renderInputArea(`section_5.${index}.title`, '', 'text', formik.values.section_5[index].title)} */}
                              {index + 1}

                            </td>
                            <td style={{ ...cellStyleW, minWidth: "600px" }}>
                              {renderTextAreaFullYY(`section_5.${index}.description`, '', formik.values.section_5[index].description)}
                              {renderTextAreaFullComments(`section_5.${index}.comments`, 'comments', formik.values.section_5[index].comments)}
                            </td>
                            <td style={{ ...cellStyleW, minWidth: "200px" }}>
                              {renderSlider(`section_5.${index}.self_scorer`, formik.values.section_5[index].self_scorer)}

                            </td>
                            <td style={{ ...cellStyleW, minWidth: "200px" }}>
                              {renderSlider(`section_5.${index}.supervisor_score`, formik.values.section_5[index].supervisor_score)}
                            </td>

                            <td style={{ ...cellStyleW, width: '100px' }}>

                              {index != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection4Array(index)} />) : null}

                              {Section4Array.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection4Array()} />) : null}

                            </td>

                          </tr>
                        </>
                      ))}

                    </tbody>
                  </table>
                  <div className="mt-4 p-2" style={{ backgroundColor: '#FEC025' }}>
                    <strong>Comments :</strong>
                  </div>
                  <div className="" style={{ ...cellStyle }} >
                    {renderTextAreaFull(`section_5.0.roles_comments`, 'Please enter your comment here...', formik.values.section_5[0].roles_comments, 8)}
                  </div>


                </div>
                {/* //!  4------- Roles & Responsibility --------- */}

                {/* //*------- Measurables-------- */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <h2 className="form-title-font">
                    Measurables
                  </h2>
                </div>
                <div className="px-0 py-3" >
                  <h4 className="subtitle-font mb-3">
                    List your measurables here. Do you understand each of them? Should we add or delete any of your measurables? Did you reach your goal for the total of all your measurables (90%) ?Your 5-7 Roles and Responsibilities. Do you understand your roles and responsibilities? Do you need to add or delete any ?
                  </h4>
                  <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, width: "auto", }} >
                          {/* My total measurable score from the last quarter in Ninety is: */}
                          My total measurable score for quarter 1:
                        </td>

                        <td style={{ ...cellStyle, width: "150px", textAlign: 'end' }} >
                          {/* {renderInputArea(`section_6.0.my_total_q1`, '', 'number', formik.values.section_6[0].my_total_q1)} */}
                          {renderPercentageInputArea(`section_6.0.my_total_q1`, formik.values.section_6[0].my_total_q1)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ ...cellStyle, width: "auto", }} >
                          My total measurable score for quarter 2:
                        </td>

                        <td style={{ ...cellStyle, width: "150px", textAlign: 'center' }} >
                          {/* {renderInputArea(`section_6.0.my_total_q2`, '', 'number', formik.values.section_6[0].my_total_q2)} */}
                          {renderPercentageInputArea(`section_6.0.my_total_q2`, formik.values.section_6[0].my_total_q2)}
                        </td>
                      </tr>

                      <tr>
                        <td style={{ ...cellStyle, width: "auto", }} >
                          My total measurable score for quarter 3:
                        </td>

                        <td style={{ ...cellStyle, width: "150px", textAlign: 'end' }} >
                          {/* {renderInputArea(`section_6.0.my_total_q3`, '', 'number', formik.values.section_6[0].my_total_q3)} */}
                          {renderPercentageInputArea(`section_6.0.my_total_q3`, formik.values.section_6[0].my_total_q3)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ ...cellStyle, width: "auto", }} >
                          My total measurable score for quarter 4:
                        </td>

                        <td style={{ ...cellStyle, width: "150px", textAlign: 'end' }} >
                          {/* {renderInputAreaPer(`section_6.0.my_total_q4`, '', 'number', formik.values.section_6[0].my_total_q4)} */}
                          {renderPercentageInputArea(`section_6.0.my_total_q4`, formik.values.section_6[0].my_total_q4)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ ...cellStyle, width: "auto", padding: '10px' }} >
                          <strong>Average:</strong>
                        </td>

                        <td style={{ ...cellStyle, width: "150px", textAlign: 'center', fontWeight: 'bold' }}>
                          {/* Calculate the average */}
                          {
                            (() => {
                              const values = [
                                formik.values.section_6[0].my_total_q1,
                                formik.values.section_6[0].my_total_q2,
                                formik.values.section_6[0].my_total_q3,
                                formik.values.section_6[0].my_total_q4
                              ];

                              // Filter out any invalid or empty values
                              const validValues = values.filter(value => !isNaN(value) && value !== '');

                              // Calculate the average if there are valid values
                              const average = validValues.length > 0
                                ? (validValues.reduce((sum, value) => sum + parseFloat(value), 0) / validValues.length).toFixed(2)
                                : 0;

                              // return average || '—';
                              return average ? `${average} %` : '—';  // Display the calculated average or a placeholder if no valid values
                            })()
                          }

                        </td>
                      </tr>
                      <tr>
                        <td style={{ ...cellStyle, }} >
                          Are your measurables on track?
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_6.0.measurable_track`, formik.values.section_6[0].measurable_track)}
                        </td>
                      </tr>

                    </tbody>
                  </table>

                  <div className="mt-4 p-2" style={{ backgroundColor: '#FEC025' }}>
                    <strong>Comments :</strong>
                  </div>
                  <div className="" style={{ ...cellStyle }} >

                    {/* <div className="" style={{ ...cellStyle }} >
                      {renderTextAreaFull(
                        `section_6.0.measurables_comments`,
                        'Please enter your comment here...',
                        `${formik.values.section_6[0].my_total_q1_comment || ''}\n${formik.values.section_6[0].my_total_q2_comment || ''}\n${formik.values.section_6[0].my_total_q3_comment || ''}\n${formik.values.section_6[0].measurables_comments || ''}`,
                        8
                      )}
                    </div> */}

                    {/* <div className="" style={{ ...cellStyle }} >
                      {formik.values.section_6[0].my_total_q1_comment && renderTextAreaFullDD(`section_6.0.my_total_q1_comment`, formik.values.section_6[0].my_total_q1_comment)}
                      {formik.values.section_6[0].my_total_q2_comment && renderTextAreaFullDD(`section_6.0.my_total_q2_comment`, formik.values.section_6[0].my_total_q2_comment)}
                      {formik.values.section_6[0].my_total_q3_comment && renderTextAreaFullDD(`section_6.0.my_total_q3_comment`, formik.values.section_6[0].my_total_q3_comment)}
                      {renderTextAreaFullMeasurables(
                        `section_6.0.measurables_comments`,
                        'Please enter your comment here...',
                        formik.values.section_6[0].measurables_comments,
                        6
                      )}
                    </div> */}
                    <div className="" style={{ ...cellStyle }}>
                      {formik.values.section_6[0].my_total_q1_comment && (
                        <InputTextarea
                          disabled={true}
                          placeholder="Please enter your comment here..."
                          name="section_6.0.my_total_q1_comment"
                          rows={6}
                          autoResize
                          id="section_6.0.my_total_q1_comment"
                          value={formik.values.section_6[0].my_total_q1_comment.replace(/\\n/g, '\n')}
                          className='px-4'
                          style={{
                            width: '100%',
                            boxSizing: 'border-box',
                            border: 'none',
                            outline: 'none',
                            fontSize: '16px',
                            color: '#495057',
                            display: 'flex',
                            alignItems: 'center',
                            paddingTop: '8px',
                            padding: '4px'
                          }}
                        />
                      )}
                      {formik.values.section_6[0].my_total_q2_comment && (
                        <InputTextarea
                          disabled={true}
                          placeholder="Please enter your comment here..."
                          name="section_6.0.my_total_q2_comment"
                          rows={6}
                          autoResize
                          id="section_6.0.my_total_q2_comment"
                          value={formik.values.section_6[0].my_total_q2_comment.replace(/\\n/g, '\n')}
                          className='px-4'
                          style={{
                            width: '100%',
                            boxSizing: 'border-box',
                            border: 'none',
                            outline: 'none',
                            fontSize: '16px',
                            color: '#495057',
                            display: 'flex',
                            alignItems: 'center',
                            paddingTop: '8px',
                            padding: '4px'
                          }}
                        />
                      )}
                      {formik.values.section_6[0].my_total_q3_comment && (
                        <InputTextarea
                          disabled={true}
                          placeholder="Please enter your comment here..."
                          name="section_6.0.my_total_q3_comment"
                          rows={6}
                          autoResize
                          id="section_6.0.my_total_q3_comment"
                          value={formik.values.section_6[0].my_total_q3_comment.replace(/\\n/g, '\n')}
                          className='px-4'
                          style={{
                            width: '100%',
                            boxSizing: 'border-box',
                            border: 'none',
                            outline: 'none',
                            fontSize: '16px',
                            color: '#495057',
                            display: 'flex',
                            alignItems: 'center',
                            paddingTop: '8px',
                            padding: '4px'
                          }}
                        />
                      )}
                      {renderTextAreaFullMeasurables(
                        `section_6.0.measurables_comments`,
                        'Please enter your comment here...',
                        formik.values.section_6[0].measurables_comments,
                        6
                      )}
                    </div>
                  </div>
                </div>
                {/* //!------- Measurables-------- */}

                {/* //*------- The 4 Management Practices ------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <h2 className="form-title-font">
                    The 4 Management Practices
                  </h2>
                </div>
                <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                  <h4 className="subtitle-font mb-3">
                    Provide feedback to your supervisor on their performance:
                  </h4>

                  <table style={{ borderCollapse: "collapse", width: "auto" }}>
                    <tbody>
                      <tr>
                        <td style={{ ...cellStylec, minWidth: "110px", }} >
                          1
                        </td>
                        <td style={{ ...cellStyle, width: "100%" }} >
                          Is he/she keeping expectations clear?
                        </td>
                        <td style={{ ...cellStyle, minWidth: "100px", }} >
                          {renderSelect(`section_7.0.keeping_expectations`, formik.values.section_7[0].keeping_expectations)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ ...cellStylec, }} >
                          2.
                        </td>
                        <td style={{ ...cellStyle, }} >
                          Is he/she communicating well?
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_7.0.communicating_well`, formik.values.section_7[0].communicating_well)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ ...cellStylec, }} >
                          3
                        </td>
                        <td style={{ ...cellStyle, }} >
                          Is he/she maintaining/participating in the L10 for the right meeting pulse?
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_7.0.meeting_pulse`, formik.values.section_7[0].meeting_pulse)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ ...cellStylec, }} >
                          4
                        </td>
                        <td style={{ ...cellStyle, }} >
                          Is he/she having quarterly conversations with you?
                        </td>
                        <td style={{ ...cellStyle, }} >
                          {renderSelect(`section_7.0.quarterly_conversations`, formik.values.section_7[0].quarterly_conversations)}
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
                {/* //!------- The 4 Management Practices ------------ */}

                {/* //*------- Work Motivators ------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <h2 className="form-title-font">
                    Work Motivators
                  </h2>
                </div>
                <div className="px-4 py-3" style={{ overflowX: "auto" }}>
                  <div className="mb-2">
                    <lable >
                      Please rank the following work motivators in order of importance, from most important to least important by placing the most important work motivator at the top.
                      This will help us understand what drives you and how we can better support your success and satisfaction at work:
                      <BsFillInfoCircleFill size={15} title='You can Drag & Drop Work Motivators to set the Priorities' className='text-gray-500 hover:text-gray-900' />

                    </lable>
                  </div>
                  {/* <OrderList
                    dataKey="id"
                    value={workMotivators}
                    onChange={(e) => setWorkMotivators(e.value)}
                    itemTemplate={itemTemplate}
                    dragdrop
                  /> */}
                  <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                    <DragMotivatorsTable motivators={workMotivators} setMotivators={setWorkMotivators} />
                  </div>
                </div>
                <div className="p-2 px-4" >
                  <lable>
                    Feel free to share additional thoughts on why these motivators matter to you ! :
                  </lable>
                </div>
                <div className="mb-2" style={{ ...cellStyle }} >
                  {renderTextAreaFull(`workMotivatorsComment`, 'Please enter your comment here...', '', 8)}
                </div>

                {/* //!------- Work Motivators ------------ */}

                {/* //*------- Quarterly Huddle conversation------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <h2 className="form-title-font">
                    Annual Performance Review
                  </h2>
                </div>
                <div className="px-0 " style={{ overflowX: "auto" }}>
                  <div className='bg-gray-800 py-2 px-4 '>
                    <h4 className="text-md font-bold form-title-font-white">
                      1. What are you most proud of achieving?
                    </h4>
                  </div>
                  <table >
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} className='w-full' >
                          {renderTextAreaFull(`most_proud`, '', formik.values.most_proud)}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                <div className="px-0 " style={{ overflowX: "auto" }}>
                  <div className='bg-gray-800 py-2 px-4 '>
                    <h4 className="text-md font-bold form-title-font-white">
                      2. What's workings ?
                    </h4>
                  </div>
                  <table >
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} className='w-full' >
                          {renderTextAreaFull(`whats_working_title`, '', formik.values.whats_working_title)}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                <div className="px-0 " style={{ overflowX: "auto" }}>
                  <div className='bg-gray-800 py-2 px-4 '>
                    <h4 className="text-md font-bold form-title-font-white">
                      3.What’s not working?
                    </h4>
                  </div>
                  <table >
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} className='w-full' >
                          {renderTextAreaFull(`whats_not_working_title`, '', formik.values.whats_not_working_title)}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                <div className="px-0 " style={{ overflowX: "auto" }}>
                  <div className='bg-gray-800 py-2 px-4 '>
                    <h4 className="text-md font-bold form-title-font-white">
                      4.Next Steps. What do you think we can do to improve and what can your supervisor do to help?
                    </h4>
                  </div>
                  <table >
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} className='w-full' >
                          {renderTextAreaFull(`next_steps_title`, '', formik.values.next_steps_title)}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                <div className="px-0 " style={{ overflowX: "auto" }}>
                  <div className='bg-gray-800  py-2 px-4 '>
                    <h4 className="text-md font-bold form-title-font-white">
                      5.Provide Feedback. How is your supervisor doing? What can he/she do for you personally and professionally?
                    </h4>
                  </div>
                  <table >
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} className='w-full' >
                          {renderTextAreaFull(`provide_feedback_title`, '', formik.values.provide_feedback_title)}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                <div className="px-0 " style={{ overflowX: "auto" }}>
                  <div className='bg-gray-800  py-2 px-4 '>
                    <h4 className="text-md font-bold form-title-font-white">
                      6. What are you doing to improve personally and professionally?
                    </h4>
                  </div>
                  <table >
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} className='w-full' >
                          {renderTextAreaFull(`improve_personally_professionally_title`, '', formik.values.improve_personally_professionally_title)}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                <div className="px-0 " style={{ overflowX: "auto" }}>
                  <div className='bg-gray-800  py-2 px-4 '>
                    <h4 className="text-md font-bold form-title-font-white">
                      7. Strengths and accomplishments:
                    </h4>
                  </div>
                  <table >
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} className='w-full' >
                          {renderTextAreaFull(`strengths_and_accomplishments`, '', formik.values.strengths_and_accomplishments)}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                <div className="px-0 " style={{ overflowX: "auto" }}>
                  <div className='bg-gray-800  py-2 px-4 '>
                    <h4 className="text-md font-bold form-title-font-white">
                      8. Performance areas which need improvement:
                    </h4>
                  </div>
                  <table >
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} className='w-full' >
                          {renderTextAreaFull(`performance_areas_which_need_improvement`, '', formik.values.performance_areas_which_need_improvement)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="px-0 " style={{ overflowX: "auto" }}>
                  <div className='bg-gray-800  py-2 px-4 '>
                    <h4 className="text-md font-bold form-title-font-white">
                      9. Plan of action toward improved performance:
                    </h4>
                  </div>
                  <table >
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} className='w-full' >
                          {renderTextAreaFull(`plan_of_action_toward_improved_performance`, '', formik.values.plan_of_action_toward_improved_performance)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="px-0 " style={{ overflowX: "auto" }}>
                  <div className='bg-gray-800 py-2 px-4 '>
                    <h4 className="text-md font-bold form-title-font-white">
                      10.  Employee comments:
                    </h4>
                  </div>
                  <table >
                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} className='w-full' >
                          {renderTextAreaFull(`employee_comments`, '', formik.values.employee_comments)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* //!------- Quarterly Huddle conversation------------ */}

                {/* //*------- Culture & Job Satisfaction ------------ */}
                <div>
                  <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                    <h2 className="form-title-font">
                      Culture & Job Satisfaction
                    </h2>
                  </div>
                  <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                    <table style={{ borderCollapse: "collapse", width: "auto" }}>

                      <tbody>
                        <tr>
                          <td style={{ ...cellStylec, minWidth: "100px", }} >
                            1
                          </td>
                          <td style={{ ...cellStyle, width: "100%" }} >
                            On a scale of 1-10, with 1 being the culture is horrible to 10 being I love the culture, how would you rate the culture at LIDA Homes?
                          </td>
                          <td style={{ ...cellStyle, minWidth: "100px" }} >
                            {renderInputAreaUptoTen('section_10.0.short_desc', '', 'number', formik.values.section_10[0].short_desc)}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...cellStylec, }} >
                            2.
                          </td>
                          <td style={{ ...cellStyle, }} >
                            On a scale of 1-10, with 1 being I am not satisfied with my job and 10 being I love my job, how would you rate your job satisfaction?
                          </td>
                          <td style={{ ...cellStyle, }} >
                            {renderInputAreaUptoTen('section_10.1.short_desc', '', 'number', formik.values.section_10[1].short_desc)}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ ...cellStyleh, }} >
                            3
                          </td>
                          <td style={{ ...cellStyle, }} colSpan={2} >
                            What is one thing we can do to improve the culture?
                          </td>

                        </tr>
                        <tr>
                          <td style={{ ...cellStyle }} colSpan={3}>
                            {renderTextAreaFull('section_10.2.short_desc', '', formik.values.section_10[2].short_desc)}
                          </td>

                        </tr>
                        <tr>
                          <td style={{ ...cellStyleh, }} >
                            4
                          </td>
                          <td style={{ ...cellStyle, }} colSpan={2} >
                            What is one thing we can do to improve your job satisfaction?
                          </td>

                        </tr>
                        <tr>
                          <td style={{ ...cellStyle, }} colSpan={3}>
                            {renderTextAreaFull('section_10.3.short_desc', '', formik.values.section_10[3].short_desc)}
                          </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* //!------- Culture & Job Satisfaction ------------ */}

                {/* //*------- Delegate & Elevate Exercise ------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <h2 className="form-title-font">
                    Delegate & Elevate Exercise
                  </h2>
                </div>
                <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                  <div className="mb-4">
                    <h4>Find your unique Abilities.</h4>
                    <p>(Complete the Delegate and Elevate exercise at the start of every year) </p>
                  </div>

                  <div >
                    <tr style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                      <th style={{ ...headerStyle }} >
                        Love/Great at
                      </th>
                      <th style={{ ...headerStyle }} >
                        Like/Good at
                      </th>
                    </tr>

                    <tr style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                      <td style={{ ...cellStyle, }} >
                        {renderTextAreaFull('section_11.0.love_great_at_desc', '', formik.values.section_11[0].love_great_at_desc)}
                      </td>
                      <td style={{ ...cellStyle, }} >
                        {renderTextAreaFull('section_11.0.like_good_at_desc', '', formik.values.section_11[0].like_good_at_desc)}
                      </td>
                    </tr>
                  </div>

                  <div>
                    <tr style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                      <th style={{ ...headerStyle }} >
                        Don't Like/Good at
                      </th>
                      <th style={{ ...headerStyle }} >
                        Don’t Like/Not Good at
                      </th>
                    </tr>
                    <tr style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                      <td style={{ ...cellStyle, }} >
                        {renderTextAreaFull('section_11.0.dont_like_good_at_desc', '', formik.values.section_11[0].dont_like_good_at_desc)}
                      </td>
                      <td style={{ ...cellStyle, }} >
                        {renderTextAreaFull('section_11.0.dont_like_not_good_at_desc', '', formik.values.section_11[0].dont_like_not_good_at_desc)}
                      </td>
                    </tr>
                  </div>


                  <table style={{ borderCollapse: "collapse", width: "100%", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, minWidth: "100px", }} colSpan={2} >
                          Identify at least one thing you do in Don’t Like/Good At or Don’t Like/Not Good At and
                          delegate it:</th>

                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td style={{ ...cellStyle, }} >
                          {renderTextAreaFull('section_11.0.notes', '', formik.values.section_11[0].notes, 6)}
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
                {/* //!------- Delegate & Elevate Exercise ------------ */}

                {/* //*------- Signature ------------ */}
                <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                  <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                    <h2 className="form-title-font">
                      Signature
                    </h2>
                  </div>

                  <div >
                    <div className="my-2 px-4">
                      <lable >
                        By selecting the checkboxes, you confirm that the document has been signed and acknowledge that further modifications to the document will no longer be possible.
                      </lable>
                    </div>
                    <tr style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr 3fr' }}>

                      <td style={{ ...cellStyle, }} >
                        {renderInputArea('employee_date', '', 'date', formik.values.employee_date)}
                      </td>
                      <td style={{ ...cellStyle, }} >
                        {renderTextAreaFullTT('employee', 'Employee:', formik.values.employee)}
                      </td>
                      <td style={{ ...cellStyle, alignItems: 'center', textAlign: 'center' }} >
                        <div style={{ height: '100%', textAlign: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                          <Checkbox
                            name="employee_sign"
                            value={formik.values.employee_sign}
                            checked={formik.values.employee_sign === 'Y'}
                            onChange={(e) => {
                              if (canSignAsEmployee) {
                                formik.setFieldValue('employee_sign', e.target.checked ? 'Y' : 'N');
                              }
                            }}
                            disabled={!canSignAsEmployee || employeeSign} // Disable if the user is not the team member
                          />
                          <span>Signed</span>
                        </div>
                      </td>
                      <td style={{ ...cellStyle, }} >
                      </td>
                    </tr>


                    <tr style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr 3fr' }}>

                      <td style={{ ...cellStyle, }} >
                        {renderInputArea('evaluated_by_date', '', 'date', formik.values.evaluated_by_date)}
                      </td>
                      <td style={{ ...cellStyle, }} >
                        {renderTextAreaFullTT('evaluated_by', 'Supervisor:', formik.values.evaluated_by)}
                      </td>
                      <td style={{ ...cellStyle, alignItems: 'center', textAlign: 'center' }} >
                        <div style={{ height: '100%', textAlign: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                          <Checkbox
                            name="evaluated_by_sign"
                            value={formik.values.evaluated_by_sign}
                            checked={formik.values.evaluated_by_sign === 'Y'}
                            onChange={(e) => {
                              if (canSignAsSupervisor) {
                                formik.setFieldValue('evaluated_by_sign', e.target.checked ? 'Y' : 'N');
                              }
                            }}
                            disabled={!canSignAsSupervisor || evaluatedBySign} // Disable if the user is not the supervisor
                          />
                          <span>Signed</span>
                        </div>
                      </td>
                      <td style={{ ...cellStyle, }} >

                      </td>
                    </tr>


                  </div>

                </div>
                {/* //!------- Signature ------------ */}



                {/* //*-------Supervisor Notes ------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <div className="builder-form-notes-center">
                    <Checkbox
                      name="supervisor_status"
                      value={formik.values.supervisor_status}
                      checked={formik.values.supervisor_status == 'Y' ? true : false}
                      onChange={(e) => {
                        formik.setFieldValue('supervisor_status', e.target.checked ? 'Y' : 'N');
                      }}
                    />
                    <label htmlFor="supervisor_notes" className="ml-2 form-title-font">Supervisor</label>
                  </div>
                </div>
                <div className="py-3" >
                  {renderTextAreaFull('supervisor_notes', '', formik.values.supervisor_notes, 8)}
                </div>
                {/* //!-------Supervisor Notes ------------ */}

                {/* //*------- VP Construction Operations Notes ------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <div className="builder-form-notes-center">
                    <Checkbox
                      name="vp_construction"
                      value={formik.values.vp_construction}
                      checked={formik.values.vp_construction == 'Y' ? true : false}
                      onChange={(e) => {
                        formik.setFieldValue('vp_construction', e.target.checked ? 'Y' : 'N');
                      }}
                    />
                    <label htmlFor="vp_construction_notes" className="ml-2 form-title-font">VP Construction Operations Notes</label>
                  </div>
                </div>
                <div className="py-3" >
                  {renderTextAreaFull('vp_construction_notes', '', formik.values.vp_construction_notes, 8)}
                </div>
                {/* //!------- VP Construction Operations Notes ------------ */}

                {/* //*------- President Notes Start ------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <div className="builder-form-notes-center">
                    <Checkbox
                      name="president"
                      value={formik.values.president}
                      checked={formik.values.president == 'Y' ? true : false}
                      onChange={(e) => {
                        formik.setFieldValue('president', e.target.checked ? 'Y' : 'N');
                      }}
                    />
                    <label htmlFor="president" className="ml-2 form-title-font">President Notes</label>
                  </div>
                </div>
                <div className="py-3" >
                  {renderTextAreaFull('president_notes', '', formik.values.president_notes, 8)}
                </div>
                {/* //!------- President Notes Start End ------------ */}

                {/* //*------- Human Resources Notes Start ------------ */}
                <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                  <div className="builder-form-notes-center">
                    <Checkbox
                      name="human_resources"
                      value={formik.values.human_resources}
                      checked={formik.values.human_resources == 'Y' ? true : false}
                      onChange={(e) => {
                        formik.setFieldValue('human_resources', e.target.checked ? 'Y' : 'N');
                        console.log(e.target.checked)
                      }}
                    />
                    <label htmlFor="he" className="ml-2 form-title-font">Human Resources Notes</label>
                  </div>
                </div>
                <div className="py-3" >
                  {renderTextAreaFull('human_resources_notes', '', formik.values.human_resources_notes, 8,)}
                </div>
                {/* //!------- Human Resources Notes End ------------ */}


              </div>
            </div>

          </form>

          {/* //!-------------------Form End------------------- */}

          <Dialog header="Enter a Custom Message" visible={isSavePopupOpen} style={{ width: '40vw' }} dismissableMask={true} onHide={() => setIsSavePopupOpen(false)}>

            <div className="p-2">
              <form onSubmit={handleSaveSubmit} className="">
                <div className="">
                  <div className='col-12 pt-2'>
                    <label htmlFor="to" >
                      {/* To : <strong> {formik.values.team_member_name} </strong> */}
                      To : <strong> {showName} </strong>
                      <Checkbox
                        name="team_member_name"
                        className='ml-4'
                        value={to}
                        checked={to == 'Y' ? true : false}
                        onChange={(e) => {
                          setTo(e.target.checked ? 'Y' : 'N');
                        }}
                      />
                    </label>
                  </div>
                  <div className='col-12 pt-2 multee'>

                    {ccDropdowng()}
                  </div>
                  <div style={{ marginLeft: '8px' }}>CC:</div>
                  {
                    selectedCCList.map((item, index) =>

                    (
                      <div style={{ fontWeight: 'bold', marginLeft: '38px', paddingBottom: '8px' }} >  {item.first_name + ' ' + item.last_name + ' (' + item.role_name + ')'} </div>)
                    )
                  }


                  <div className='col-12 pt-2 '>
                    <label htmlFor="customSubject" >Subject </label>
                    <InputTextarea
                      id="customSubject"
                      value={customSubject}
                      onChange={(e) => setCustomSubject(e.target.value)}
                      className="p-inputtext p-component p-2"
                      style={{ width: '95%', marginTop: '10px' }}
                    />
                  </div>

                  <div className="col-12 pt-2">
                    <label htmlFor="customMessage" className='pb-10'>Message</label>
                    <Editor
                      id="customMessage"
                      value={customMessage}
                      onTextChange={(e) => {
                        // console.log(e.htmlValue);
                        setCustomMessage(e.htmlValue)
                      }}
                      style={{ height: '220px' }} />
                  </div>
                  <div className=" flex flex-wrap justify-content-center ">
                    <Button label="Submit" type="submit" className="p-2 px-3 customSave-button" severity="success" />
                  </div>
                </div>
              </form>
            </div>
          </Dialog>

          <SignatureModal
            visible={isSignatureModalVisible}
            onHide={() => setSignatureModalVisible(false)}
            onSave={handleSignatureSave}
          />

        </div>
      )}

    </>
  );
}

export default PerformanceReviewForm;
